module.exports = __webpack_public_path__ + "img/profile2x.242e74cf.png";